import { connect } from 'react-redux'
import { getFilteredTypes } from 'Services/GraphFilterUtils'
import { getUid, getNodeLabel } from 'Services/WeaverUtils'
import ColorService from 'Services/ColorService'
import { withFilterData } from 'Components'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import { setTypeFilters, updateTypeFilter, updateTypeFilters } from 'Actions/graphFilter'
import { store } from '~/Store'
import { TYPE } from 'Types'
import { DisabledTypes } from 'Model'
import Feather from '@sysunite/react-feather'
import FilterHeader from './FilterHeader'
import FilterBody from './FilterBody'
import GraphFilterItem from './GraphFilterItem'
import tabStyles from './tabStyles'

typeFilterSelector = createSelector((state) ->
  state.graphFilter.typeFilters
, _.values)

GraphFilterTypes = ({ items }) ->
  dispatch = useDispatch()
  typeFilters = useSelector(typeFilterSelector)

  [filterValue, setFilterValue] = useState("")
  [configNode, setConfigNode] = useState(undefined )

  useEffect(->
    dispatch(setTypeFilters(
      _.keyBy(
        _.sortBy(items, ['enabled', (item) -> item.label.toLowerCase()])
      , 'id')
    ))
    ( ->
      setConfigNode(await DisabledTypes.load())
    )()
    undefined
  , [items])

  CellRenderItem = ({ item, props... }) ->
    { explore: { disabledTypes }} = store.getState()
    color = ColorService.getColorForType(item.id)
    enableByDefault = !disabledTypes.includes(item.id)

    itemProps = {
      color: color
      itemType: TYPE
      enabled: item.enabled
      value: item.id
      label: item.label
      enableByDefault
      ...props
    }

    <GraphFilterItem { itemProps... } />

  <div style={tabStyles}>
    <FilterHeader updateFilters={updateTypeFilters}
                  items={typeFilters}
                  idField='id'
                  onFilter={setFilterValue} />
    <FilterBody configNode={configNode}
                items={typeFilters}
                idField='id'
                filterValue={filterValue}
                updateFilter={updateTypeFilter}
                CellRenderItem={CellRenderItem} />
  </div>

export default withFilterData(GraphFilterTypes, getFilteredTypes, typeFilterSelector)
